module.exports = __webpack_public_path__ + "img/Icon-Check-Circle.41a599f0.svg";